import { ILogisticsProvider } from '@nkr/models/index';

export interface ISelectedLogisticsProvider extends ILogisticsProvider {
    selected: boolean
}